import React from "react";


const Card04 = ({item, index}) => {
    return (
        <div className="card04-wrapper">
            <div className="row">
                <div className="col-md-3">
                    <div className="card04-img">
                        <img src={item.image} alt={item.title} />
                    </div>
                </div>
                <div className="col-md-9">
                    <div className="card04-detail">
                        <div className="card04-date">
                            {item.date}
                        </div>
                        <div className="card04-title font-face-pop">
                            {item.title}
                        </div>
                        <div className="card04-description">
                            {item.content}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Card04;